import script from "./ProjectSideArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSideArea.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSideArea.vue?vue&type=style&index=0&id=8dfeb6a0&lang=scss"

const __exports__ = script;

export default __exports__